import { Component, HostListener, Input, OnChanges, SimpleChanges, viewChild, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DrawerComponent, DrawerSelectEvent } from '@progress/kendo-angular-layout';
import { map } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BIModulesService } from '../../bi-modules.service';
import { BISearchComponent } from '../bi-search/bi-search.component';
import { IMenuItem } from 'bi-interfaces';
import { menuIcon, SVGIcon,xIcon } from '@progress/kendo-svg-icons';
import { UiProfileService } from '../../services/ui-profile.service';

@Component({
  selector: 'Bi-Sidebar',
  templateUrl: './bi-side-bar.component.html',
  styleUrls: ['./bi-side-bar.component.scss']
})
export class BISideBarComponent implements OnChanges {
  public selected: string = "";
  @Input() items!: Array<IMenuItem>;
  @Input() excludedFromSearchIndexes: number[] = [];
  collapsed: boolean = false;
  mobile: boolean = false;
  closed: boolean = false;
  collapseSideContent: boolean = true;
  public searchValue: string = '';
  public searchDataList: any[] = [];
  public searchResults: any[] = [];
  public selectedMenuItem: string[] = [];
  public showSearchInSideContent: boolean = true;
  public menuSVG: SVGIcon = menuIcon;
  public closeSVG: SVGIcon = xIcon;
  @ViewChild('BiSearch') BiSearch!: BISearchComponent;
  @ViewChild('drawer') drawer!: DrawerComponent;
  // @ViewChild('SideBarContent') sideBarContent! : SideBarContentComponent;
  @Input() isRightToLeft!: any;
  isRight!: boolean;
  @HostListener('click', ['$event.target']) onClick(e: HTMLElement) {
    if (e.className.includes("sidebar-container")) {
      this.collapsed = false; 
      this.closed = true; 
    }
  }
  constructor(
    private router: Router, private breakpointObserver: BreakpointObserver, 
    public biService: BIModulesService,
    private uiProfileService: UiProfileService
  ) {
    this.isRight = localStorage.getItem("isRightToLeft") === 'rtl'
  }
  ngOnInit(): void {
    const mobileQuery = this.breakpointObserver.observe('(max-width: 576px)');

    mobileQuery.pipe(
      map((result) => result.matches)
    ).subscribe((matches) => {
      this.mobile = matches;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']?.currentValue) {
      this.searchDataList = this.flattenMenuItems( this.items.filter((_, index) => !this.excludedFromSearchIndexes.includes(index)));
    }
  }

  public onSelect(ev: DrawerSelectEvent | any): void {
    this.resetSelectedMenuItem();
      this.collapsed = true;
      this.collapseSideContent = false;
      this.showSearchInSideContent = (ev?.item?.children);
      this.selected = ev.item.text;
  }

  changeBackGround(): void {
    this.closed ? this.collapsed = false : this.collapsed = !this.collapsed;
  }

  navigateToScreen(path: string): void {
    if (path?.includes('https') || path?.includes('www')||path?.includes('http')) {
      window.open(path, '_blank');
    }
    else {

      this.router.navigateByUrl(`${path}`)
    }

    if(this.mobile)
        this.closeMenu()

    // this.uiProfileService.navigatedToScreenSubject.next(this.sideBarContent.activeButton);
  }

  closeMenu(): void {
    this.closed = true;
    this.collapsed = false;
  }

  backToNav(): void {
    this.selected = '';
    this.resetSelectedMenuItem();
  }

  public CheckToggleDrawer() {
    this.drawer?.toggle();
    this.showSearchInSideContent = (this.drawer?.expanded && this.selectedMenuItem?.length > 0);
  }

  private selectMenuItem(searchItem: { path: string, text: string, pathInBreadCrumb: string[] }) {
    let checkCondition = (searchItem.pathInBreadCrumb?.length > 0) ? (searchItem.pathInBreadCrumb[0]) : (searchItem.text);
    let selectedMenuItemIndex = (this.items.findIndex(e => e.text === checkCondition));
    if(selectedMenuItemIndex != -1){
      this.items.forEach(i => i.selected = false);
      this.items[selectedMenuItemIndex].selected = true;
      this.onSelect({ item: { ...this.items[selectedMenuItemIndex] } });
      this.drawer?.toggle(false);
  
      if (this.items[selectedMenuItemIndex].children) {
        this.selectedMenuItem = [...searchItem.pathInBreadCrumb, ...[searchItem.text]];
      }
    }

    if (this.searchValue?.length > 0) {
      this.BiSearch.resetControl();
      this.searchValue = '';
      this.searchResults = [];
    }
  }

  private resetSelectedMenuItem() {
    if (this.selectedMenuItem?.length > 0) this.selectedMenuItem = [];
  }

  public getRouteToNavigate(event: { path: string, text: string, pathInBreadCrumb: string[] }) {
    this.selectMenuItem({ ...event });
    this.navigateToScreen(event?.path);
    this.uiProfileService.emitrecentPage({PageName: event.text, PageUrl: event.path});

  }

  public getSearchChanges(event: { value: string, searchResults: any[] }) {
    this.searchValue = event?.value;
    this.searchResults = event?.searchResults;
  }

  private flattenMenuItems(items: any[]): any[] {
    function flatArray(items: any, pathInBreadCrumb?: string) {
      return items.flatMap((item: any) => (item.children != null) ? flatArray(item.children,
        (pathInBreadCrumb ? (pathInBreadCrumb + ',' + item.text) : item.text)) :
        {
          text: item.text, path: item.path, pathInBreadCrumb:
            (pathInBreadCrumb ? pathInBreadCrumb.split(',') : [])
        });
    }    

    let flattenItems = flatArray(items);
    const filteredItems = flattenItems.filter((i: any) => i.path);
    return filteredItems;
  }



}
